import { Button } from '@mui/material';

export const HelpBanner = () => {
  return (
    <div className="flex items-center justify-between px-6 py-4 overflow-hidden bg-center bg-no-repeat bg-cover rounded-lg bg-help-banner">
      <p className="font-semibold text-white">
        Need more help? Just send us a message — we're here to assist!
      </p>
      <a href="mailto:support@mydra.io" target="_blank">
        {/** FIXME: add get help */}
        <Button variant="contained">Get help!</Button>
      </a>
    </div>
  );
};
